import { useState } from "react";
import { useSelector } from "react-redux";

import H2RButton from "./H2RComponents/H2RButton";
import H2RInput from "./H2RComponents/H2RInput";
import H2RHeading from "./H2RComponents/H2RHeading";
import * as cuesApi from "../api/cue";
import * as socketActions from "../actions/socketActions";
import { faCheck, faClose, faExternalLink } from "@fortawesome/free-solid-svg-icons";

export default function Licence() {
	const [key, setKey] = useState("");
	const [checking, setChecking] = useState(false);
	const [error, setError] = useState(null);

	const isPro = useSelector((state) => state.main?.licenced?.checked);
	const keyInUse = useSelector((state) => state.main?.licenced?.licence);
	const activationId = useSelector(
		(state) => state.main?.licenced?.activationId
	);

	return (
		<div className="px-20 py-10 h-screen w-screen bg-gray-700 flex flex-col justify-center items-center space-y-3">
			{!isPro && (
				<>
					<H2RHeading type="h4">What is H2R Graphics Pro?</H2RHeading>
					<H2RButton
						text={"Learn more"}
						size="small"
						colour="dark"
						icon={faExternalLink}
						css="w-min whitespace-pre"
						onClick={() => {
							return socketActions.visitExternal("https://h2r.graphics/pro");
						}}
					/>
					<span className="h-px w-full bg-gray-600"></span>

					<H2RHeading type="h4">Enter your licence key</H2RHeading>
					<div className="flex justify-center space-x-2">
						<H2RInput
							placeholder="ABCDEFG-1234-5678-91011-HIJKLMNOP"
							colour="light"
							value={key}
							onChange={(change) => {
								setKey(change);
							}}
						/>
						<H2RButton
							disabled={key === "" || checking}
							text={checking ? "Checking..." : "Check"}
							size="small"
							icon={faCheck}
							css="w-min h-7"
							onClick={() => {
								setError(null);
								setChecking(true);
								return cuesApi.addLicenceKey(key).then((res) => {
									setChecking(false);

									if (res.message) {
										setError(
											"There was an issue validating the licence. Please try again."
										);
									}
								});
							}}
						/>
					</div>
					{error && <span className="mt-2 text-sm text-red-500">{error}</span>}
				</>
			)}

			{isPro && (
				<>
					<H2RHeading type="h4">You're a pro! 🙌</H2RHeading>

					<div className="flex flex-col justify-center text-center space-y-2">
						<span className="text-gray-400 text-sm uppercase">Licence key</span>
						<span className="text-gray-200">{`${keyInUse}-••••-••••-••••-••••••••••••`}</span>
						<span className="text-gray-500 select-text text-xs pb-4">
							Activation ID: {`${activationId}`}
						</span>
						<H2RButton
							disabled={checking}
							text={checking ? "Deactivating..." : "Deactivate"}
							// text="Deactivate"
							size="small"
							icon={faClose}
							css="w-full h-7"
							colour="light"
							onClick={() => {
								setChecking(true);
								setKey("");
								return cuesApi.removeLicenceKey(key).then((res) => {
									setChecking(false);
								});
							}}
						/>
					</div>
				</>
			)}
		</div>
	);
}
